import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import ShareTwoCentsContent from '../../../components/Pages/ShareYourTwoCents';
import CreateNewPostContent from '../../../components/Pages/ShareYourTwoCents/CreateNewPost';
import CategoryProvider from '../../../components/Pages/Home/HowMuchToTip/CategoryProvider';

const { displayName } = config;

export default function CreateNewPost(): React.ReactElement {
  document.title = `${displayName}: Create new post`;

  return (
    <Layout>
      <CategoryProvider>
        <CreateNewPostContent />
      </CategoryProvider>
    </Layout>
  );
}
